import { render, staticRenderFns } from "./AdmissionDialog.vue?vue&type=template&id=8d3a11f2&scoped=true&lang=pug"
import script from "./AdmissionDialog.vue?vue&type=script&lang=js"
export * from "./AdmissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a11f2",
  null
  
)

export default component.exports